import { selectRiskConfig } from '@Selectors/Risk.selectors';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import { noConditionData } from '../RiskDetails.component';
import useGetWeightedScores from './useGetWeightedScores';
import { useEffect, useState } from 'react';

export default function useRiskDetailsColumnOrder() {
	const riskConfig = selectRiskConfig();
	const [cofFilled, setCofFilled] = useState(false);
	const [lofFilled, setLofFilled] = useState(false);

	const weightedScores = useGetWeightedScores();

	const weightedCofColumnNames = weightedScores.cofScores?.map(
		cof => cof.field,
	);

	const weightedLofColumnNames = weightedScores.lofScores.map(
		lof => lof.field,
	);

	const isIndividualScoresEnabled = useIsFeatureEnabled(
		'info-360-risk-datagrid-individual-scores',
	);

	const [columnOrder, setColumnOrder] = useState<string[]>([
		'ASSET_ID',
		'RISK_CHANGE',
		'CURRENT_RISK',
		'CURRENT_COF',
		'CURRENT_LOF',
		...(!noConditionData(riskConfig.riskSetting.assetType)
			? ['CONDITION_DATA']
			: []),
		'GRADE',
		'Menu',
	]);

	useEffect(() => {
		if (
			isIndividualScoresEnabled &&
			!cofFilled &&
			weightedCofColumnNames.length > 0
		) {
			setColumnOrder(co => [...co, ...weightedCofColumnNames]);
			setCofFilled(true);
		}
	}, [weightedCofColumnNames]);

	useEffect(() => {
		if (
			isIndividualScoresEnabled &&
			!lofFilled &&
			weightedLofColumnNames.length > 0
		) {
			setColumnOrder(co => [...co, ...weightedLofColumnNames]);
			setLofFilled(true);
		}
	}, [weightedLofColumnNames]);

	return { columnOrder, setColumnOrder };
}
